export const IDENTITY_TYPE_TWITTER = 'twitter';
export const IDENTITY_TYPE_MASTODON = 'mastodon';
